import { ImgHTMLAttributes, PureComponent } from "react";
import loadImg from './image/loading.gif';
import errorImg from './image/no.png';

export interface Props {
  srcAddress: string,
  alt: string,
}

type State = {
  imgSrc: string,
  loaded: boolean
}

export default class ImageLoad extends PureComponent<Props, State> {
  state = {
    imgSrc: loadImg,
    loaded: false
  };

  loadImage(path: string) {
    const image = new Image();
    return new Promise<HTMLImageElement>((resolve, reject) => {
      image.onload = () => resolve(image);
      image.onerror = reject;
      image.src = path;
    });
  }
  handleOnLoad = async () => {
    const { srcAddress } = this.props;
    if (this.state.loaded) return;
    try {
      const { src } = await this.loadImage(srcAddress);
      this.setState({ imgSrc: src })
    } catch {
      this.setState({ imgSrc: errorImg })
    } finally {
      this.setState({ loaded: true })
    }
  };

  render() {
    const { alt } = this.props, { imgSrc } = this.state;
    return (
      <img
        src={imgSrc}
        alt={alt}
        onLoad={this.handleOnLoad}
      />
    )
  }
}

